import shared from './shared';
import authorization from './authorization';
import strategySandbox from './strategySandbox';

export default {
    shared,
    authorization,
    strategySandbox
};
